export default __webpack_public_path__ + "static/media/api-doc.4248c72b.yml";